<template>
    <div class="vue-template">
        <div style="height: 500px;">
            <quiz-modal v-show="isModalVisible" @close="closeModal" />
        </div>
    </div>
</template>

<script>
    import quizModal from './QuizModal.vue';
    export default {
        name: "aptitude-test",
        components: {
            quizModal
        },
        data () {
            return {
                isModalVisible: true
            }
        },
        methods: {
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.$emit('close');
                this.isModalVisible = false;
            }
        },
    };
</script>

